import React from "react"

import styles from "../styles/components/footer.module.scss"
import logo from "../images/footer/footerLogo.png"

// Images
import nugoLogo from "../images/nugo-logo.svg"

export default function footer() {
  return (
    <footer className={styles.footer}>
      {/* <div className={styles.social} >
        <a href="https://www.instagram.com/madfitpro/" target="blank" rel="nofollow">
          <img src={socialInstagram} alt="instagram" />
        </a>
        <a href="https://www.facebook.com/madfit.lk/" target="blank" rel="nofollow">
          <img src={socialFacebook} alt="facebook" />
        </a>
      </div> */}
      <p className={styles.copyright}>
        MadFitPro Transformations. Copyright {new Date().getFullYear()}. All
        Rights Reserved
      </p>
      <a
        href="https://www.nugo.xyz"
        rel="nofollow"
        target="blank"
        className={styles.copyright}
      >
        <p className={`${styles.copyright} ${styles.hide}`}>
          Developed by Nugo{" "}
          <span>
            <img src={nugoLogo} alt="nugo" />
          </span>
        </p>
      </a>
    </footer>
  )
}
